@if (showModal) {
<app-dialog-title>{{ "generate-package" | transloco }}</app-dialog-title>
<mat-dialog-content class="content">
  @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  } @if (!errorMessage && batchActionState !== 'COMPLETED') {
  <div>
    @if (genType === 'DRAFT') {
    <div>
      <p>
        {{ 'are-you-sure-you-want-to-generate-package-for-the-batch-and-selected-tax-return-alias-s' | transloco: {taxReturnAlias} }}
      </p>
    </div>
    } @if (genType === 'STANDARD') {
    <div>
      <p>
        {{ 'are-you-sure-you-want-to-finalise-the-package-for-the-batch-and-selected-tax-return-alias' | transloco:{taxReturnAlias} }}
      </p>
    </div>
    }
    <!-- TRANSLOCO TODO -->
    @if (runningTasksList?.length > 0 || queuedTasksList?.length > 0) {
    <div>
      <p>This task will run after the following tasks are complete:</p>
      @if (runningTasksList?.length > 0) {
      <div>
        <label>Current Running Generation Tasks: </label>
        @for (task of runningTasksList; track task) {
        <p>{{ task }}</p>
        }
      </div>
      }
      <br />
      @if (queuedTasksList?.length > 0) {
      <div>
        <label>Queued Tasks: </label>
        @for (task of queuedTasksList; track task) {
        <p>{{ task }}</p>
        }
        <br />
      </div>
      }
    </div>
    }
    <!-- END OF TRANSLOCO TODO-->
  </div>
  } @if (!errorMessage && batchActionState === 'COMPLETED') {
  <div>
    @if (genType === 'DRAFT') {
    <div>
      <p>
        {{
          "the-batch-generate-package-process-has-started-this-may-take-a-while-but-we-will-update-you-on-the-progress-this-process-cannot-be-run-again-until-the-package-has-finished-generating"
            | transloco
        }}
      </p>
      <p>
        {{ 'if-you-update-the-tax-return-alias-again-you-will-need-to-generate-the-draft-package-for-the-batch-again-so-that-the-documents-get-updated-with-the-latest-changes' | transloco: {taxReturnAlias} }}
      </p>
    </div>
    } @if (genType === 'STANDARD') {
    <div>
      <p>
        {{
          "the-batch-finalise-package-process-has-started-this-may-take-a-while-but-we-will-update-you-on-the-progress-this-process-cannot-be-run-again-until-the-package-has-finished-finalising"
            | transloco
        }}
      </p>
      <p>
        {{ 'if-you-update-the-tax-return-alias-again-you-will-need-to-generate-the-draft-package-for-the-batch-and-finalise-it-again-so-that-the-documents-get-updated-with-the-latest-changes' | transloco: {taxReturnAlias} }}
      </p>
    </div>
    }
  </div>
  }
</mat-dialog-content>
@if (batchActionState !== 'COMPLETED') {
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button
    class="ui primary button"
    (click)="batchGenerate()"
    [disabled]="submitButtonDisabled"
    [ngClass]="{ loading: batchActionState === 'LOADING' }"
  >
    {{ "generate-package" | transloco }}
  </button>
</mat-dialog-actions>
} @if (batchActionState === 'COMPLETED') {
<mat-dialog-actions align="end">
  <button class="ui primary button" (click)="onClose(true)">
    {{ "ok" | transloco }}
  </button>
</mat-dialog-actions>
} }
